import React, { useContext, useState, useRef } from "react";
import { debug } from "../utils";
import { connect } from "react-redux";
import CreateReportModal from "./CreateReportModal";
import ThemeListModal from "./theme/ThemeListModal";
import { TableContext } from "../index";
import { showSuccessToast, showWarningToast, showDangerToast } from "../validation/ToastContainer";
import { deleteReports, uploadReportLogo } from "./reportService";
import SearchInputV2 from "../view/SearchInputV2";

function ReportsTableHeader({ activeTab, onTabChange }) {

    const { config, setConfig } = useContext(TableContext);
    const [showModal, setShowModal] = useState(false);
    const [showThemeModal, setShowThemeModal] = useState(false);
    //new states to check seleted reports count & disable delete button
    const selectedCount = config.selected ? config.selected.length : 0;
    const isDeleteDisabled = selectedCount === 0;

    // Search state - stored in context for table filtering
    const handleSearch = (e) => {
        const value = e.target.value;
        const searchKey = activeTab === "scheduled" ? "scheduleSearchTerm" : "searchTerm";
        setConfig({ ...config, [searchKey]: value });
    };
    const searchValue = activeTab === "scheduled" ? (config.scheduleSearchTerm || '') : (config.searchTerm || '');
    const searchPlaceholder = activeTab === "scheduled" ? "Search schedules..." : "Search reports...";

    const onDeleteClick = async () => {
        const selectedReports = config.selected;

        if (!selectedReports.length) {
            showWarningToast('No selected reports to remove', 'Remove Report', 'aborted')
        } else {
            await deleteReports(selectedReports);
            showSuccessToast(`${selectedReports.length > 1 ? 'Reports were' : 'Report was'} removed`, 'Remove report');
            setConfig({ ...config, lastUpdated: Date.now() })
        }
    }


    //const [image, setImage] = useState(null);
    const fileInputRef = useRef(null);

    const uploadLogo = (event) => {
        //setImage(event.target.files[0]);
        fileInputRef.current.click();
    }

    const onImgChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            uploadReportLogo(file).then(async response => {
                if (response.ok) {
                    showSuccessToast(
                        "Logo Uploaded",
                        "Report Logo"
                    );
                } else {
                    response = await response.json()
                    showDangerToast(response.message, "Error")
                }
                return !!response.ok
            });
        }
    };

    return (
        <>
            {showModal && <CreateReportModal handleClose={() => setShowModal(false)} />}
            <ThemeListModal
                isOpen={showThemeModal}
                onClose={() => setShowThemeModal(false)}
            />

            {/* V2 Header Section */}
            <div className="oct_analysis-header-v2 mt-0">
                <div className="oct_analysis-title-section">
                    <h2>REPORTS</h2>
                </div>
                <div className="oct_analysis-actions">
                    <button onClick={() => setShowModal(true)} className="oct_btn-export-v2">Create Report</button>
                    <button onClick={() => setShowThemeModal(true)} className="oct_btn-export-v2">Create Customize Template</button>
                    <button onClick={() => uploadLogo()} className="oct_btn-outline-v2">Upload Logo</button>
                    <input
                        id="file-upload"
                        type="file"
                        ref={fileInputRef}
                        onChange={onImgChange}
                        accept=".jpg, .jpeg, .png"
                        className="d-none"
                    />
                    {activeTab !== "scheduled" && (
                        <button
                            onClick={() => !isDeleteDisabled && onDeleteClick()}
                            className={`oct_btn-outline-v2 ${isDeleteDisabled ? 'oct_btn-disabled' : ''}`}
                            disabled={isDeleteDisabled}
                            title={isDeleteDisabled ? "Select at least one report to delete" : ""}
                        >
                            Delete Selected ({selectedCount})
                        </button>
                    )}
                </div>
            </div>

            {/* V2 Search Section */}
            <div className="oct_filter-section-v2 reports-toolbar-filter">
                <SearchInputV2
                    value={searchValue}
                    onChange={handleSearch}
                    placeholder={searchPlaceholder}
                    className="m-0"
                />
            </div>

            <div className="reports-tabs-row">
                <div className={`reports-tab-bar ${activeTab === "scheduled" ? "is-scheduled" : "is-generated"}`}>
                    <button
                        type="button"
                        className={`reports-tab-button ${activeTab !== "scheduled" ? "active" : ""}`}
                        onClick={() => onTabChange("generated")}
                    >
                        Generated
                    </button>
                    <button
                        type="button"
                        className={`reports-tab-button ${activeTab === "scheduled" ? "active" : ""}`}
                        onClick={() => onTabChange("scheduled")}
                    >
                        Scheduled
                    </button>
                </div>
            </div>
        </>
    );
}

function mapStateToProps(state) {
    debug("ReportsTableHeader mapStateToProps", state);
    return state;
}

export default connect(mapStateToProps)(ReportsTableHeader);
